import { DELAY_TIME } from "@constants";
import { SxProps, Theme, Tooltip, tooltipClasses } from "@mui/material";
import { SHBox } from "@components/design-systems";

type MSTableColumnSettingIconButtonProps = {
  title: string;
  icon: JSX.Element;
  popperSx?: SxProps<Theme>;
};

export const MSTableColumnSettingIconButton = ({
  title,
  icon,
  popperSx,
}: MSTableColumnSettingIconButtonProps) => {
  return (
    <Tooltip
      enterDelay={DELAY_TIME}
      enterNextDelay={DELAY_TIME}
      title={title}
      placement={"bottom"}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: "5px",
                ...popperSx,
              },
          },
        },
      }}
    >
      <SHBox component={"span"}>
        {icon}
      </SHBox>
    </Tooltip>
  );
};
